import { FC } from "react";
import { Tooltip } from "antd";
import { ReactComponent as ArrowIcon } from "../../../../assets/icons/svg/arrow-up.svg";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { IndustryGrowth as IndustryGrowthType } from "../../../../types/IntelligenceTypes";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./IndustryGrowth.module.less";

function getArrowClass(direction?: string) {
    switch (direction) {
        case "up":
            return styles.arrowUp;
        case "down":
            return styles.arrowDown;
        case "flat":
            return styles.arrowNeutral;
        default:
            return styles.arrowNeutral;
    }
}

interface IndustryGrowthProps {
    data?: IndustryGrowthType;
}

export const IndustryGrowth: FC<IndustryGrowthProps> = ({ data }) => {
    const arrowClass = getArrowClass(data?.direction);
    const points = data?.growthTrends.concat(data?.demandDrivers);

    return (
        <GenericCard size="larger" className={styles.card}>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <div className={styles.title}>Overall industry growth and demand</div>
                    <Tooltip title="This metric provides insights into the current and projected growth trends within the vendor's industry, as well as the demand for products or services. Understanding these trends is crucial for strategic planning, investment decisions, and competitive analysis.">
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </div>
                <div className={styles.contentMain}>
                    <ArrowIcon className={arrowClass} />
                </div>
                <ul className={styles.points}>{points?.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
        </GenericCard>
    );
};
